import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-snow',
  templateUrl: './snow.component.html',
  styleUrls: ['./snow.component.scss']
})
export class SnowComponent implements OnInit, OnDestroy {
  private snowflakeCount = 60; // Número máximo de copos visibles a la vez
  private snowContainer!: HTMLElement;
  private snowInterval!: any;
  private routerSubscription!: Subscription;

  constructor(private renderer: Renderer2, private router: Router) {}

  ngOnInit(): void {
    // Crear el contenedor para los copos
    this.snowContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.snowContainer, 'snow');
    this.renderer.appendChild(document.body, this.snowContainer);

    // Iniciar nieve al cargar la página
    this.startSnow();

    // Reiniciar nieve al navegar
    // this.routerSubscription = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     this.restartSnow();
    //   }
    // });
  }

  startSnow(): void {
    let activeSnowflakes = 0; // Contador de copos activos

    this.snowInterval = setInterval(() => {
      if (activeSnowflakes >= this.snowflakeCount) return; // Evitar saturación

      const snowflake = this.renderer.createElement('div');
      this.renderer.addClass(snowflake, 'snowflake');
      snowflake.textContent = '❄'; // Texto del copo

      // Propiedades aleatorias
      const size = Math.random() * 1.5 + 0.5 + 'em';
      const left = Math.random() * 100 + '%';
      const duration = Math.random() * 5 + 5 + 's';
      const delay = Math.random() * 5 + 's';

      // Aplicar estilos
      this.renderer.setStyle(snowflake, 'fontSize', size);
      this.renderer.setStyle(snowflake, 'left', left);
      this.renderer.setStyle(snowflake, 'animationDuration', duration);
      this.renderer.setStyle(snowflake, 'animationDelay', delay);

      // Incrementar contador y agregar copo
      activeSnowflakes++;
      this.renderer.appendChild(this.snowContainer, snowflake);

      // Eliminar el copo después de que salga de la pantalla
      setTimeout(() => {
        this.renderer.removeChild(this.snowContainer, snowflake);
        activeSnowflakes--; // Reducir contador
      }, parseFloat(duration) * 2000);
    }, 600); // Crear copos cada 500ms

  }

  stopSnow(): void {
    clearInterval(this.snowInterval); // Detener la creación
  }

  restartSnow(): void {
    this.stopSnow(); // Detener cualquier animación previa
    this.startSnow(); // Reiniciar la animación
  }

  ngOnDestroy(): void {
    this.stopSnow(); // Detener al destruir el componente
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Limpiar la suscripción
    }
  }
}